import Axios from 'axios';
import config from '../config';

export default Axios.create({
  baseURL: config.apiBaseURL,
  timeout: 10000,
  headers: {
    Authorization: localStorage.getItem('auth_token') ? `Bearer ${localStorage.getItem('auth_token')}` : null,
  },
});
